import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export const LegalShell = ({ title, updated, children }) => (
  <div className="min-h-screen grain">
    <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <div className="flex items-center justify-between gap-4">
        <Logo size="md" testId="legal-logo" />
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-slate-900">
          <ArrowLeft className="w-4 h-4" /> Back to Unbound
        </Link>
      </div>
      <p className="mt-8 rule-label">Last updated {updated}</p>
      <h1 className="mt-3 text-4xl font-extrabold">{title}</h1>
      <div className="mt-8 space-y-7">{children}</div>
      <div className="mt-14 flex gap-4 text-sm font-semibold">
        <Link to="/terms" className="text-blue-700 hover:underline">Terms &amp; Conditions</Link>
        <Link to="/privacy" className="text-blue-700 hover:underline">Privacy Policy</Link>
        <Link to="/about" className="text-blue-700 hover:underline">About Unbound</Link>
      </div>
    </div>
  </div>
);

export const Clause = ({ n, title, children }) => (
  <section data-testid={`clause-${n}`}>
    <h2 className="font-display text-xl font-bold">
      {n}. {title}
    </h2>
    <div className="mt-2 space-y-3 text-sm text-slate-600 leading-relaxed">{children}</div>
  </section>
);
